export const defaultProductsRelatedModelData = {
  activeLinkIndex: null,
  isLoading: false
};

export const ActionType = {
  CHANGE_LIST: `CHANGE_LIST`
};

export const CONNECTOR_URL = `/assets/components/products/connector.php`;

export const RequestAction = {
  GET_RELATED: `get_related`
};

export const RESET_PARENT_HEIGHT_TIMEOUT_TIME = 500;
